import { TMixpanelProperties } from '@webtrader/core/mix-panel/types';
import { EMixpanelProperties } from '@webtrader/core/services/analysis/constants';
import { authService } from '@webtrader/core/services/auth';

class UserHelper {
  public createUserAccountProperties = (): TMixpanelProperties => {
    const { selectedTradingAccount, selectedTradingAccountBalances } = authService.context || {};
    const { metatraderId } = selectedTradingAccount || {};
    const { balance, equity, profitLoss, marginLevel } = selectedTradingAccountBalances
      ? selectedTradingAccountBalances || {}
      : selectedTradingAccount || {};

    return {
      [EMixpanelProperties.METATRADER_ID]: metatraderId,
      [EMixpanelProperties.EQUITY]: equity || 0,
      [EMixpanelProperties.ACCOUNT_BALANCE]: balance || 0,
      [EMixpanelProperties.REALISE_PROFIT_LOSS]: profitLoss || 0,
      [EMixpanelProperties.MARGIN_LEVEL]: marginLevel || 0
    };
  };
}

const userHelper = new UserHelper();
export default userHelper;
